import Entity from "@/services/westore/entities/entity";

class CommonEndPoints extends Entity {
  static getProductsType(params = {}) {
    return super.getAll("/product-types", params);
  }

  static getCities(id) {
    return super.getAll(`/countries/${id}/cities`);
  }
}

export default CommonEndPoints;
